import { render } from "./Fish.vue?vue&type=template&id=3577d3ac&scoped=true"
import script from "./Fish.vue?vue&type=script&lang=js"
export * from "./Fish.vue?vue&type=script&lang=js"

import "./Fish.vue?vue&type=style&index=0&id=3577d3ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3577d3ac"]])

export default __exports__